<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCpchofer" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objCpChofer.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="ApellidoPat">Apellido Paterno</label>
							<input type="text" v-model="objCpChofer.ApellidoPat" class="form-control" id="ApellidoPat" placeholder="Ingresar Apellido Paterno" />
							<CValidation v-if="this.errorvalidacion.ApellidoPat" :Mensaje="'*'+errorvalidacion.ApellidoPat[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="ApellidoMat">Apellido Materno</label>
							<input type="text" v-model="objCpChofer.ApellidoMat" class="form-control" id="ApellidoMat" placeholder="Ingresar Apellido Materno" />
							<CValidation v-if="this.errorvalidacion.ApellidoMat" :Mensaje="'*'+errorvalidacion.ApellidoMat[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="RFC">RFC</label>
							<input type="text" v-model="objCpChofer.RFC" class="form-control" id="RFC" placeholder="Ingresar RFC" />
							<CValidation v-if="this.errorvalidacion.RFC" :Mensaje="'*'+errorvalidacion.RFC[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="CURP">CURP</label>
							<input type="text" v-model="objCpChofer.CURP" class="form-control" id="CURP" placeholder="Ingresar CURP" />
							<CValidation v-if="this.errorvalidacion.CURP" :Mensaje="'*'+errorvalidacion.CURP[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="NumLicencia">Número de Licencia</label>
							<input type="text" v-model="objCpChofer.NumLicencia" class="form-control" id="NumLicencia" placeholder="Ingresar Número de Licencia" />
							<CValidation v-if="this.errorvalidacion.NumLicencia" :Mensaje="'*'+errorvalidacion.NumLicencia[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Pais">País</label>
							<select @change="GetEstados();" v-model="objCpChofer.Pais" class="form-control-search form-select" id="Pais">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in Paises" :key="index" :value="item.Clave">{{item.Clave + ' - ' + item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.Pais" :Mensaje="'*'+errorvalidacion.Pais[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Estado">Estado</label>
							<select @change="GetMunicipios();GetLocalidades();" v-model="objCpChofer.Estado" class="form-control-search form-select" id="Estado">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in Estados" :key="index" :value="item.Clave">{{item.Clave + ' - ' + item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.Estado" :Mensaje="'*'+errorvalidacion.Estado[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Municipio">Municipio</label>
							<select @change="GetColonias()" v-model="objCpChofer.Municipio" class="form-control-search form-select" id="Municipio">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in Municipios" :key="index" :value="item.Clave">{{item.Clave + ' - ' + item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.Municipio" :Mensaje="'*'+errorvalidacion.Municipio[0]"/>
						</div>

					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Colonia">Colonia</label>
							<select v-model="objCpChofer.Colonia" class="form-control-search form-select" id="Colonia">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in Colonias" :key="index" :value="item.Clave">{{item.Clave + ' - ' + item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.Colonia" :Mensaje="'*'+errorvalidacion.Colonia[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Localidad">Localidad</label>
							<select v-model="objCpChofer.Localidad" class="form-control-search form-select" id="Localidad">
								<option :value="''">Seleccione una opción</option>
								<option v-for="(item, index) in Localidades" :key="index" :value="item.Clave">{{item.Clave + ' - ' + item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.Localidad" :Mensaje="'*'+errorvalidacion.Localidad[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Calle">Calle</label>
							<input type="text" v-model="objCpChofer.Calle" class="form-control" id="Calle" placeholder="Ingresar Calle" />
							<CValidation v-if="this.errorvalidacion.Calle" :Mensaje="'*'+errorvalidacion.Calle[0]"/>
						</div>

					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Número Exterior">Número Exterior</label>
							<input type="text" v-model="objCpChofer.NumExt" class="form-control" id="NumInt" placeholder="Ingresar Número Exterior" />
							<CValidation v-if="this.errorvalidacion.NumExt" :Mensaje="'*'+errorvalidacion.NumExt[0]"/>
						</div>
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="NumInt">Número Interior</label>
							<input type="text" v-model="objCpChofer.NumInt" class="form-control" id="NumInt" placeholder="Ingresar Número Interior" />
							<CValidation v-if="this.errorvalidacion.NumInt" :Mensaje="'*'+errorvalidacion.NumInt[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="CodigoPostal">Código Postal</label>
							<input type="text" v-model="objCpChofer.CodigoPostal" class="form-control" id="CodigoPostal" placeholder="Ingresar Código Postal" />
							<CValidation v-if="this.errorvalidacion.CodigoPostal" :Mensaje="'*'+errorvalidacion.CodigoPostal[0]"/>
						</div>
					</div>
						
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Referencias">Referencias</label>
							<textarea v-model="objCpChofer.Referencias" class="form-control" id="Referencias" placeholder="Ingresar Referencias" rows="3"></textarea>
							<CValidation v-if="this.errorvalidacion.Referencias" :Mensaje="'*'+errorvalidacion.Referencias[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCpChofer',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCpChofer: {
				IdChofer: 0,
				Nombre: '',
				ApellidoPat: '',
				ApellidoMat: '',
				RFC: '',
				CURP: '',
				NumLicencia: '',
				Pais:'',
				Estado: '',
				Municipio: '',
				Colonia: '',
				Localidad: '',
				Calle: '',
				NumInt: '',
				NumExt: '',
				CodigoPostal: '',
				Referencias: '',
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			Paises: [],
			Estados: [],
			Municipios: [],
			Colonias: [],
			Localidades: [],
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCpChofer.IdChofer == 0) {
				await this.$http.post(
					'cpChoferes',this.objCpChofer
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'cpChoferes/'+this.objCpChofer.IdChofer,
					this.objCpChofer
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cpChoferes/"+this.objCpChofer.IdChofer
            ).then((res) => {
                this.objCpChofer = res.data.data;
				const resp = res.data.data;
				this.objCpChofer.Municipio = resp.Municipio ? resp.Municipio : '';
				this.objCpChofer.Localidad = resp.Localidad ? resp.Localidad : '';
				this.objCpChofer.Colonia = resp.Colonia ? resp.Colonia : '';
				this.$http.get("cpDataCombosUbicacion",{
					params:{
						Pais:this.objCpChofer.Pais,
						Estado:this.objCpChofer.Estado,
						Municipio:this.objCpChofer.Municipio,
					}
				}).then((res)=>{
					this.Estados = res.data.data.ListEstado;
					this.Municipios = res.data.data.ListMunicipio;
					this.Localidades = res.data.data.ListLocalidad;
					this.Colonias = res.data.data.ListColonia;
				}).catch(err => console.error(err));
				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCpChofer.Fecha.replace(/-/g,'\/');
                this.objCpChofer.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCpChofer = {
				IdChofer: 0,
				Nombre: '',
				ApellidoPat: '',
				ApellidoMat: '',
				RFC: '',
				CURP: '',
				NumLicencia: '',
				Pais:'',
				Estado: '',
				Municipio: '',
				Colonia: '',
				Localidad: '',
				Calle: '',
				NumInt: '',
				NumExt: '',
				CodigoPostal: '',
				Referencias: ''
            }
            this.errorvalidacion = [];
        },
		GetPaises()
		{
			this.$http.get("cpPaises", {
				params:{
					simple:1,
				},
			}).then((res)=> {
				this.Paises = res.data.data;
			}).catch(err => console.error(err))
		},
		GetEstados()
		{
			this.objCpChofer.Municipio=''; 
			this.objCpChofer.Colonia='';
			this.objCpChofer.Localidad='';
			this.$http.get("cpEstados", {
				params:{
					ClavePais: this.objCpChofer.Pais,
					simple: 1,
				}
			}).then((res) => {
				this.Estados = res.data.data;
			});
		},
		GetMunicipios()
		{
			this.objCpChofer.Municipio='';
			this.objCpChofer.Colonia='';
			this.objCpChofer.Localidad='';
			this.$http.get("cpMunicipios", {
				params:{
					ClaveEstado:this.objCpChofer.Estado,
					simple: 1,
				}
			}).then((res) => {
				this.Municipios = res.data.data;
			});
		},
		GetColonias()
		{
			this.objCpChofer.Colonia='';
			this.$http.get("cpColonias", {
				params:{
					IdEstado:this.objCpChofer.Estado,
					IdMunicipio:this.objCpChofer.Municipio,
					simple: 1,
				}
			}).then((res) => {
				this.Colonias = res.data.data;
			});
		},
		GetLocalidades()
		{
			this.$http.get("cpLocalidades", {
				params:{
					ClaveEstado:this.objCpChofer.Estado,
					simple: 1,
				}
			}).then((res) => {
				this.Localidades = res.data.data;
			});
		},
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
			this.GetPaises();

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCpChofer.IdChofer = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
